import { SelfServeOnboardingSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import * as z from "zod";

export const completeSelfServeOnboarding = {
  name: "completeSelfServeOnboarding" as const,
  input: SelfServeOnboardingSettingsParser,
  output: z.null(),
};
